import * as Actions from '../actions';

const initialState = {
    studentAssignment: {
        header: {
            student_assignment_id:      0,
            company_calendar_event_id:  0,
            assignment_id:              0,
            auth_id:                    0,
            student_id:                 0,
            SubmissionDate:             '',
            Score:                      0,
            IsGraded:                   0,
            GradedDate:                 '',
        },
        assetList: [],
        gradebook_detail: {
            gradebook_detail_id:       0,
            gradebook_id:              0,
            company_calendar_event_id: 0,
            student_id:                0,
            student_quiz_id:           0,
            student_assignment_id:     0,
            Score:                     0,
            RetakeEvent:               0,
        },
    },
    currentStudent: {
        student_id: 0,
        FirstName: '',
        LastName: '',
        Email: '',
        Address: '',
        City: '',
        State: '',
        Zip: '',
        Phone: '',
        Active: 0,
    },
    isStudentAssignmentLoaded: false,
    nextEvent: {
        EventName: 'None',
        EventType: 'None',
        company_calendar_event_id: 0
    },
    prevEvent: {
        EventName: 'None',
        EventType: 'None',
        company_calendar_event_id: 0
    }
}

const assignmentReducer = function (state = initialState, action) {
    switch (action.type) {
        case(Actions.GET_STUDENT_ASSIGNMENT):
        {
            return {
                ...state,
                studentAssignment: action.payload,
                isStudentAssignmentLoaded: true
            }
        }

        case(Actions.GET_STUDENT_INFO):
        {
            return {
                ...state,
                currentStudent: action.payload
            }
        }

        case(Actions.UPDATE_STUDENT_ASSIGNMENT):
        {
            return {
                ...state,
                studentAssignment: {
                    ...state.studentAssignment,
                    header: {
                        ...state.studentAssignment.header,
                        ...action.payload,
                    }
                }
            }
        }

        case(Actions.GET_ASSIGNMENT_ASSET_LIST):
        {
            return {
                ...state,
                assignmentList: action.payload
            }
        }

        case(Actions.GET_NEXT_EVENT_FOR_CONTINUE):
        {
            return {
                ...state,
                nextEvent: action.payload.nextEvent,
                prevEvent: action.payload.prevEvent
            }
        }

        default:
        {
            return state;
        }
    }
}

export default assignmentReducer;


// WEBPACK FOOTER //
// src/main/content/assignment/store/reducers/student_assignment.reducer.js